<script lang="ts">
    import { browser } from '$app/environment';
    import { OVERLAY_MANAGER_CONTEXT_KEY, type OverlayManagerContext } from './utils';
    import { getContext } from 'svelte';
    import { page } from '$app/stores';
    import OverlayLayout from './OverlayLayout.svelte';
    import OverlayOutletPage from './OverlayOutletPage.svelte';

    const manager: OverlayManagerContext | undefined = getContext<OverlayManagerContext>(
        OVERLAY_MANAGER_CONTEXT_KEY
    );
    if (!manager) {
        throw new Error('OverlayOutlet must be used within an OverlayManager Context');
    }

    $: shallowRoutingActive = Boolean($page.state.overlay);
</script>

{#if shallowRoutingActive}
    <OverlayLayout on:close={manager?.closeOverlay}>
        <OverlayOutletPage />
    </OverlayLayout>
{/if}
